<template>
    <div class="shop__header">
        <h1 class="shop__heading mb-4">{{heading}}</h1>
        <p class="shop__paragraph">{{subheading}}</p>
    </div>
</template>

<script>
export default {
    name: 'ShopHeader',
    props: {
        heading: {
            required: true,
            type: String,
        },
        subheading: {
            required: true,
            type: String,
        },
    },
};
</script>
